import countryList from 'react-select-country-list';

export const ALL_COUNTRIES = countryList().getData();
